<template>
  <div class="warranty-lookup-page">
    <KTCodePreview v-bind:title="'Tra cứu bảo hành'">
      <template v-slot:toolbar>
        <div class="row"></div>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col md="4">
            <b-form-input
              v-model.trim="params.imeiCode"
              type="text"
              placeholder="Nhập mã IMEI"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <b-form-input
              v-model.trim="params.customerPhoneNumber"
              type="text"
              placeholder="Số điện thoại khách hàng"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="2">
            <b-button
              variant="primary"
              size="sm"
              class="btn font-weight-bold btn-size"
              @click="onFilter"
              :disabled="onLoading"
              >Tìm kiếm</b-button
            >
          </b-col>
        </b-row>

        <b-table
          :items="listWarrantyRegistrations"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
          class="warranty-table"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(warrantyBillNumber)="row">
            <div class="font-weight-bold text-primary hover">
              <div @click="openListBillPage(row.item)">
                {{ row.item.warrantyBillNumber }}
              </div>
            </div>
          </template>

          <template v-slot:cell(customer)="row">
            <div>
              <div class="font-weight-bold">
                {{ row.item.customerName }}
              </div>
              <div
                type="button"
                class="hover"
                @click="openCustomerDetailPage(row.item)"
              >
                {{ row.item.customerPhoneNumber }}
              </div>
            </div>
          </template>

          <template v-slot:cell(productInfo)="row">
            <div class="font-weight-bold">
              <div v-if="row.item.productName">
                {{ row.item.productName }}
              </div>
              <div
                style="
                  font-size: 12px;
                  font-style: italic;
                  color: rgb(46, 125, 50);
                "
              >
                IMEI: {{ row.item.imeiCode }}
              </div>
            </div>
          </template>

          <template v-slot:cell(warrantyInfo)="row">
            <div>
              <div
                class="font-weight-bold hover mb-1"
                @click="openListBillPage(row.item)"
              >
                {{ row.item.warrantyProductName }}
              </div>
              <div class="text-info text-primary">
                Ngày kích hoạt:
                <span class="font-weight-bold">{{
                  formatDate(row.item.activeDate)
                }}</span>
              </div>
              <div class="text-info text-primary">
                Ngày hết hạn:
                <span class="font-weight-bold">{{
                  formatDate(row.item.expiredDate)
                }}</span>
              </div>
              <div class="text-info text-primary">
                Sử dụng tối đa:
                <span class="font-weight-bold">{{
                  row.item.maxWarrantyUsage === -1
                    ? 'Không giới hạn'
                    : row.item.maxWarrantyUsage
                }}</span>
              </div>
              <div
                v-if="row.item.isRefunded"
                class="text-danger font-weight-bold"
              >
                Gói bảo hành đã trả hàng
              </div>
            </div>
          </template>

          <template v-slot:cell(usedCount)="row">
            <div>
              <span class="font-weight-bold">{{ row.item.usedCount }}</span>
            </div>
          </template>

          <template v-slot:cell(status)="row">
            <span
              class="label font-weight-bold label-lg label-inline mb-2"
              :class="
                row.item.isWarrantyActive
                  ? 'label-light-success'
                  : 'label-light-danger'
              "
            >
              {{ IS_ACTIVE_NAME[Number(row.item.isWarrantyActive)] }}
            </span>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <p class="mt-3 text-dark font-weight-bold">
              Tổng: {{ totalItems }}
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="page"
              :total-page="totalPages"
              :linkParams="{}"
              @page-change="fetchData()"
            >
            </BPaginationNavCustom>
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import { makeToastFaile } from '@/utils/common';
import { formatDate, DATE_FORMAT } from '@/utils/date';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { IS_ACTIVE_NAME } from '@/utils/enum-name';

export default {
  data() {
    return {
      DATE_FORMAT,
      onLoading: false,
      listWarrantyRegistrations: [],
      fields: [
        {
          key: 'warrantyBillNumber',
          label: 'ID',
          thStyle: { fontWeight: 600, color: '#181c32', width: '6%' },
        },
        {
          key: 'customer',
          label: 'Khách hàng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'productInfo',
          label: 'Sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'warrantyInfo',
          label: 'Gói bảo hành',
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'usedCount',
          label: 'Đã sử dụng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'lastUsageDate',
          label: 'Sử dụng gần nhất',
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? formatDate(value, DATE_FORMAT) : '';
          },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-center',
        },
      ],
      totalPages: 1,
      totalItems: 0,
      page: 1,
      limit: 10,
      params: {
        imeiCode: null,
        customerPhoneNumber: null,
      },
      IS_ACTIVE_NAME,
    };
  },
  methods: {
    formatDate,
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-warranty-registration',
      });
      this.fetchData();
    },
    setParamFilter() {
      return {
        ...this.params,
        page: this.page,
        limit: this.limit,
      };
    },
    fetchData: async function (page) {
      try {
        if (this.onLoading) return;
        this.onLoading = true;
        this.page = page ?? this.$route.query.page ?? 1;
        const params = this.setParamFilter();
        const {
          data: { data },
        } = await ApiService.query('warranty-registrations', {
          params,
        });
        this.listWarrantyRegistrations = data.result;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
      } catch (error) {
        const message =
          error.response?.data?.message ?? error.message ?? 'Network error';
        makeToastFaile(message);
      } finally {
        this.onLoading = false;
      }
    },
    openListBillPage({ warrantyBillNumber }) {
      const routeData = this.$router.resolve({
        name: 'list-bill',
        query: {
          id: warrantyBillNumber,
        },
      });
      window.open(routeData.href, '_blank');
    },
    openCustomerDetailPage({ customerId, customerPhoneNumber }) {
      const routeData = this.$router.resolve({
        name: 'update-customer',
        query: {
          id: customerId,
          phoneNo: customerPhoneNumber,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Bảo hành', route: 'warranty-registrations' },
      { title: 'Tra cứu bảo hành' },
    ]);
  },
  created() {
    this.fetchData();
  },
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
  },
};
</script>

<style scoped>
.warranty-table {
  background: #f7fafd;
}
.font-weight-bold {
  font-weight: 600 !important;
}
.text-primary {
  color: #007bff !important;
}
.text-info {
  font-size: 13px;
  color: #007bff;
}

.btn-size {
  width: 90px;
}
.status-expired {
  color: #e74c3c;
  font-weight: bold;
}
.status-active {
  color: #27ae60;
  font-weight: bold;
}
.hover {
  cursor: pointer;
}
.hover:hover {
  opacity: 0.7;
  text-decoration: underline;
}
</style>
